import { __module as t } from "../../../_virtual/isURL.js";
import { a as r } from "./util/assertString.js";
import { i as e } from "./isFQDN.js";
import { i as o } from "./isIP.js";
import { m as l } from "./util/merge.js";
!function (t, i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), i.default = function (t, r) {
    if ((0, n.default)(t), !t || /[\s<>]/.test(t) || 0 === t.indexOf("mailto:") || (r = (0, u.default)(r, c)).validate_length && t.length >= 2083 || !r.allow_fragments && t.includes("#") || !r.allow_query_components && (t.includes("?") || t.includes("&"))) return !1;
    if ((v = (t = (v = (t = (v = t.split("#")).shift()).split("?")).shift()).split("://")).length > 1) {
      if (o = v.shift().toLowerCase(), r.require_valid_protocol && -1 === r.protocols.indexOf(o)) return !1;
    } else if (r.require_protocol) return !1;else if ("//" === t.substr(0, 2)) {
      if (!r.allow_protocol_relative_urls) return !1;
      v[0] = t.substr(2);
    }
    if ("" === (t = v.join("://"))) return !1;
    if ("" === (t = (v = t.split("/")).shift()) && !r.require_host) return !0;
    if ((v = t.split("@")).length > 1) {
      if (r.disallow_auth || "" === v[0] || (l = v.shift()).indexOf(":") >= 0 && l.split(":").length > 2) return !1;
      var e,
        o,
        l,
        i,
        f,
        h,
        m,
        v,
        g,
        y = function (t) {
          if (Array.isArray(t)) return t;
        }(e = l.split(":")) || function (t, r) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
            var e = [],
              o = !0,
              l = !1,
              i = void 0;
            try {
              for (var n, s = t[Symbol.iterator](); !(o = (n = s.next()).done) && (e.push(n.value), !r || e.length !== r); o = !0);
            } catch (t) {
              l = !0, i = t;
            } finally {
              try {
                o || null == s.return || s.return();
              } finally {
                if (l) throw i;
              }
            }
            return e;
          }
        }(e, 2) || function (t, r) {
          if (t) {
            if ("string" == typeof t) return p(t, r);
            var e = Object.prototype.toString.call(t).slice(8, -1);
            if ("Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e) return Array.from(t);
            if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return p(t, r);
          }
        }(e, 2) || function () {
          throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }(),
        b = y[0],
        j = y[1];
      if ("" === b && "" === j) return !1;
    }
    f = v.join("@"), m = null, g = null;
    var w = f.match(_);
    if (w ? (i = "", g = w[1], m = w[2] || null) : (i = (v = f.split(":")).shift(), v.length && (m = v.join(":"))), null !== m && m.length > 0) {
      if (h = parseInt(m, 10), !/^[0-9]+$/.test(m) || h <= 0 || h > 65535) return !1;
    } else if (r.require_port) return !1;
    return r.host_whitelist ? d(i, r.host_whitelist) : !!((0, a.default)(i) || (0, s.default)(i, r) || g && (0, a.default)(g, 6)) && (i = i || g, !(r.host_blacklist && d(i, r.host_blacklist)));
  };
  var n = f(r),
    s = f(e),
    a = f(o),
    u = f(l);
  function f(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function p(t, r) {
    (null == r || r > t.length) && (r = t.length);
    for (var e = 0, o = Array(r); e < r; e++) o[e] = t[e];
    return o;
  }
  var c = {
      protocols: ["http", "https", "ftp"],
      require_tld: !0,
      require_protocol: !1,
      require_host: !0,
      require_port: !1,
      require_valid_protocol: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_protocol_relative_urls: !1,
      allow_fragments: !0,
      allow_query_components: !0,
      validate_length: !0
    },
    _ = /^\[([^\]]+)\](?::([0-9]+))?$/;
  function d(t, r) {
    for (var e = 0; e < r.length; e++) {
      var o = r[e];
      if (t === o || "[object RegExp]" === Object.prototype.toString.call(o) && o.test(t)) return !0;
    }
    return !1;
  }
  t.exports = i.default, t.exports.default = i.default;
}(t, t.exports);
var i = t.exports;
export { i };